import { Card } from "@/components/ui/card";
import { Crown, Sparkles, Star } from "lucide-react";

const tiers = [
  { name: "New to the Herd", events: 0, emoji: "🌱" },
  { name: "Flow Finder", events: 10, emoji: "🌿" },
  { name: "Balanced Cowgirl", events: 25, emoji: "🌻" },
  { name: "Wellness Wrangler", events: 50, emoji: "🌸" },
  { name: "Iconic Cowgirl", events: 75, emoji: "🌺" },
  { name: "Legendary Yogi Cowgirl", events: 100, emoji: "👑", isLegendary: true },
];

export const DemoTiers = () => {
  return (
    <Card className="p-5 bg-card/95 backdrop-blur-sm border-border/50">
      <div className="space-y-4">
        {/* Header */}
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 mb-1">
            <Star className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-primary">Level Up Your Journey</span>
            <Star className="w-4 h-4 text-primary" />
          </div>
        </div>
        
        {/* Tier progression */}
        <div className="relative">
          {/* Connection line */}
          <div className="absolute left-[22px] top-4 bottom-4 w-0.5 bg-gradient-to-b from-muted via-primary/50 to-amber-400" />
          
          <div className="space-y-2">
            {tiers.map((tier, index) => (
              <div 
                key={index}
                className={`flex items-center gap-3 p-2 rounded-lg transition-all ${
                  tier.isLegendary 
                    ? 'bg-gradient-to-r from-amber-500/20 via-yellow-400/20 to-amber-500/20 border border-amber-400/30 animate-pulse' 
                    : 'bg-muted/30'
                }`}
              >
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-lg relative z-10 ${
                  tier.isLegendary 
                    ? 'bg-gradient-to-br from-amber-400 to-yellow-500 shadow-lg shadow-amber-400/30' 
                    : 'bg-muted'
                }`}>
                  {tier.emoji}
                </div>
                <div className="flex-1">
                  <p className={`text-sm font-medium ${tier.isLegendary ? 'text-amber-400' : 'text-foreground'}`}>
                    {tier.name}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {tier.events === 0 ? 'Start here!' : `${tier.events} events attended`}
                  </p>
                </div>
                {tier.isLegendary && (
                  <Crown className="w-5 h-5 text-amber-400" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
};

export const DemoLegendaryTeaser = () => {
  return (
    <Card className="p-5 bg-gradient-to-br from-amber-950/50 via-card to-amber-950/30 border-amber-400/30 backdrop-blur-sm">
      <div className="space-y-4 text-center">
        {/* Crown with glow */}
        <div className="relative w-20 h-20 mx-auto">
          <div className="absolute inset-0 bg-amber-400/30 rounded-full blur-xl animate-pulse" />
          <div className="relative w-full h-full rounded-full bg-gradient-to-br from-amber-400 to-yellow-500 flex items-center justify-center">
            <Crown className="w-10 h-10 text-amber-950" />
          </div>
        </div>
        
        <div>
          <h3 className="text-lg font-bold text-amber-400">Become Legendary</h3>
          <p className="text-sm text-muted-foreground mt-1">
            First 25 to reach 100 events unlock
          </p>
        </div>
        
        {/* Benefits */}
        <div className="space-y-2 text-left bg-muted/20 rounded-lg p-3">
          <div className="flex items-center gap-2 text-sm">
            <Sparkles className="w-4 h-4 text-amber-400 flex-shrink-0" />
            <span className="text-foreground">Free Yogi Pack (worth $50+)</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Sparkles className="w-4 h-4 text-amber-400 flex-shrink-0" />
            <span className="text-foreground">Exclusive profile glow effect</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Sparkles className="w-4 h-4 text-amber-400 flex-shrink-0" />
            <span className="text-foreground">Premium features for life</span>
          </div>
        </div>
        
        {/* Urgency */}
        <div className="bg-amber-400/10 rounded-full py-2 px-4 inline-block">
          <p className="text-sm font-semibold text-amber-400">
            Limited spots available!
          </p>
        </div>
      </div>
    </Card>
  );
};
